let apiInstance = null;
let cfProxyInstance = null;
export const setApiInstance = (instance) => {
    apiInstance = instance;
};
export const setCloudflareWorkerReverseProxyInstance = (instance) => {
    cfProxyInstance = instance;
};
const notRegistered = (name) => () => {
    throw new Error(`[api-client] ${name} has not been registered. Call ${name === 'api' ? 'setApiInstance' : 'setCloudflareWorkerReverseProxyInstance'}(instance) at app bootstrap before using endpoint functions.`);
};
const createLazyProxy = (get, name) => new Proxy({}, {
    get(_target, prop) {
        var _a;
        const instance = (_a = get()) !== null && _a !== void 0 ? _a : notRegistered(name)();
        const value = instance[prop];
        return typeof value === 'function' ? value.bind(instance) : value;
    },
});
export const api = createLazyProxy(() => apiInstance, 'api');
export const cloudflareWorkerReverseProxy = createLazyProxy(() => cfProxyInstance, 'cloudflareWorkerReverseProxy');
//# sourceMappingURL=instance.js.map